<template>
    <a :href="createCookie('quickcookie','true',7)" @click="buyItem" class="txtButtonAddBasket2" title="Checkout">  BUY NOW</a>
</template>


<script>
  import {bus} from '../../../bus'
    export default {
      props: [
            'product1',
            'product2',
            'type',
            'stylesClass',
            'text'
        ],
        methods: {
            createCookie(name, value, days) {
               // alert(name, value, days);
               var expires = "";
               if (days) {
                  var date = new Date();
                  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                  expires = "; expires=" + date.toUTCString();
               }
               document.cookie = name + "=" + value + expires + "; path=/";

               // NOte: THere's no such function
               // submitDoc('addtobasket')
            },
            buyItem(e) {
                e.preventDefault()
                var type = $('[name=radio_engine_type]:checked').val();
                console.log(type);
                var productSave = {};
                
                if(type == 1) { // gasoline
                  productSave = {
                      id: this.product1.id,
                      name: this.product1.name,
                      quantity: 1,
                      comment: this.product1.comment || ''
                  }
                }
                else if( type == -1) { // diesel
                  productSave = {
                      id: this.product2.id,
                      name: this.product2.name,
                      quantity: 1,
                      comment: this.product2.comment || ''
                  }
                }
                
                let items = JSON.parse(localStorage.getItem('items')) || []
                // checking if the product exists into items
                console.log(items);
                let productFound = false
                items.forEach(item => {
                    if (item.id == productSave.id) {
                        item.quantity += 1
                        productFound = true
                    }
                })
                // if doesn't exist should push one
                if (!productFound) {
                    items.push(productSave)
                }
                localStorage.setItem('items', JSON.stringify(items))
                localStorage.setItem('payment_gateway', 2)
                bus.$emit('cart-was-updated')
                location.href = '/cart.php?act=step2'
            }
        }
    }
</script>